const normalizeBaseUrl = (url) => (url || "").replace(/\/+$/, "");
const DEFAULT_ASSISTANT_BASE = "https://api.dev.theharrispoll.dev/ai-assistant";

export const getAssistantBaseUrl = () => {
  const envBase = import.meta.env.VITE_ASSISTANT_URL;
  const base = envBase || DEFAULT_ASSISTANT_BASE;
  return normalizeBaseUrl(base);
};

export const buildAssistantUrl = (path = "") => {
  const base = getAssistantBaseUrl();
  const cleaned = String(path || "").replace(/^\/+/, "");
  return `${base}/${cleaned}`;
};

export const buildAssistantHeaders = (extra = {}) => {
  const token = localStorage.getItem("token");
  const headers = { ...extra };
  if (!headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  if (token && !headers.Authorization) {
    headers.Authorization = token;
  }
  return headers;
};
